var map = {
	"./App": 8710,
	"./App.vue": 8710,
	"./assets/Alexandr.png": 4411,
	"./assets/Alpha_Wallet.jpg": 5680,
	"./assets/Artem.png": 143,
	"./assets/Denis.png": 6491,
	"./assets/Rustam.png": 3128,
	"./assets/Slava.png": 2891,
	"./assets/Ushu_Pro.jpg": 4629,
	"./assets/Vladisllav.png": 7196,
	"./assets/background.webp": 7477,
	"./assets/blob.gif": 1070,
	"./assets/butterfly.gif": 2016,
	"./assets/crystal.gif": 8467,
	"./assets/cube.gif": 3852,
	"./assets/drainer.png": 5721,
	"./assets/logo.png": 3153,
	"./assets/og-image.png": 4522,
	"./assets/parser.png": 1889,
	"./assets/phish.png": 3498,
	"./assets/romb.gif": 1995,
	"./assets/smile.gif": 3873,
	"./assets/sphere.gif": 4964,
	"./assets/torus.gif": 7718,
	"./assets/wawes.gif": 4818,
	"./assets/wawes2.gif": 6432,
	"./components/MainPage": 9198,
	"./components/MainPage.vue": 9198,
	"./components/TestPageView": 8664,
	"./components/TestPageView.vue": 8664,
	"./components/blocks/AboutUs": 344,
	"./components/blocks/AboutUs.vue": 344,
	"./components/blocks/ExperienceBlock": 573,
	"./components/blocks/ExperienceBlock.vue": 573,
	"./components/blocks/FooterBlock": 7367,
	"./components/blocks/FooterBlock.vue": 7367,
	"./components/blocks/HeaderComp": 1322,
	"./components/blocks/HeaderComp.vue": 1322,
	"./components/blocks/LetsTalk": 3176,
	"./components/blocks/LetsTalk.vue": 3176,
	"./components/blocks/MainBlock": 5619,
	"./components/blocks/MainBlock.vue": 5619,
	"./components/blocks/MobileMenu": 1893,
	"./components/blocks/MobileMenu.vue": 1893,
	"./components/blocks/ProjectsBlock": 5743,
	"./components/blocks/ProjectsBlock.vue": 5743,
	"./components/blocks/TeamBlock": 1791,
	"./components/blocks/TeamBlock.vue": 1791,
	"./components/elements/BottomGradient": 6286,
	"./components/elements/BottomGradient.vue": 6286,
	"./components/elements/ExperienceCard": 7270,
	"./components/elements/ExperienceCard.vue": 7270,
	"./components/elements/ProjectCard": 228,
	"./components/elements/ProjectCard.vue": 228,
	"./components/elements/SkillBadge": 2263,
	"./components/elements/SkillBadge.vue": 2263,
	"./i18n": 4147,
	"./i18n.js": 4147,
	"./main": 1406,
	"./main.js": 1406,
	"./plugins/gsapDirectives": 9263,
	"./plugins/gsapDirectives.js": 9263,
	"./router": 9325,
	"./router/": 9325,
	"./router/index": 9325,
	"./router/index.js": 9325
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5538;